module.exports = __webpack_public_path__ + "static/media/selection_viaplay.dde759bf.png";